import axios from 'axios';
import config from './config'
import { toDateString } from './pages/dashboard/views/inspect/util'
import _ from 'lodash'

const API_ROOT = config.API_ROOT

export function portalLogin(email, password){
	return axios.post(API_ROOT + '/portal/login', { username: email, password: password })
}

export function portalLoginFBBC(email, password){
	return axios.post(API_ROOT + '/portal/login-fbbc', { username: email, password: password })
}

export function loadProfile(id) {
	return axios.get(API_ROOT + '/portal/' + id, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function addPortalAccount(id, data){
	return (
		axios.post(API_ROOT + '/portal/accounts/' + id +'/', data, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function getAccounts(id) {
	return axios.get(API_ROOT + '/portal/accounts/' + id , { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function deletePortalAccount(managerID, accountID) {
	return axios.delete(API_ROOT + '/portal/accounts/' + managerID + '/' + accountID, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function inspectPortalAccount(managerID, accountID) {
	return axios.get(API_ROOT + '/portal/inspect/' + managerID + '/' + accountID, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

//inspectPortalAccount only gets latest 5 check-ins
export function getCheckIns(portalID, accountID, user_id) {
	return axios.get(`${API_ROOT}/portal/inspect/check-ins/${portalID}/${accountID}/${user_id}/300/0`, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function getPortalAccountTrackerData(managerID, accountID, dateString) {
	return axios.get(API_ROOT + '/portal/tracker/' + managerID + '/' + accountID + '/' + dateString, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function getPortalAccountWeighInDetails(managerID, accountID, dateString) {
	return axios.get(API_ROOT + '/portal/weigh-in-details/' + managerID + '/' + accountID + '/' + dateString, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function getPortalAccountWeighInPhotos(managerID, accountID, weightID) {
	return axios.get(API_ROOT + '/portal/weigh-in-photos/' + managerID + '/' + accountID + '/' + weightID, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function fetchPortalPaymentItems(managerID, paymentID) {
	return axios.get(API_ROOT + '/portal/payment-items/' + managerID + '/' + paymentID, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function searchAccount(id, key, val) {
	return axios.get(API_ROOT + '/portal/accounts/' + id + '/' + key + '/' + val, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function setPassword(id, password){
	const body = {
		password: password
	}

	return axios.put(API_ROOT + '/portal/login/' + id, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function editPortalAccount(managerID, body){
	return (
		axios.put(API_ROOT + '/portal/accounts/' + managerID +'/', body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function updatePortalBilling(managerID, nonce, billingAddress){
	const body = {
		nonce: nonce,
		billingAddress: billingAddress
	}

	return (
		axios.post(API_ROOT + '/portal/update-billing/' + managerID +'/', body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function createPortalTransaction(managerID, amount){
	const body = {
		amount: amount
	}

	return (
		axios.post(API_ROOT + '/portal/transaction/' + managerID, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function updatePortalAddress(managerID, info){
	const body = {
		info: info
	}

	return (
		axios.post(API_ROOT + '/portal/update-address/' + managerID +'/', body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function editPortalUser(id, req) {
	return (
		axios.put(API_ROOT + '/success/portal/' + id, req, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function updatePortalUser(id, mods) {
	return (
		axios.put(`${API_ROOT}/portal/profile/${id}`, mods, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function createTicket(name, email, subject, message) {
	return (
		axios.post(API_ROOT + '/contact', {
		name: name,
		email: email,
		subject: subject,
		message: message
		})
	)
}

export function cancelPortalUser(managerID, billingDate) {
	const body = {
	  endDate: billingDate
	}
	return axios.put(API_ROOT + '/portal/cancel-user/' + managerID, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function reactivatePortalUser(managerID) {
	const body = {
	  endDate: null
	}
	return axios.put(API_ROOT + '/portal/cancel-user/' + managerID, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function createVerificationCode(email) {
	const body = {
		email_address: email,
	}

	return (
		axios.post(API_ROOT + '/portal/verify-code/', body)
	)
}

export function checkVerificationCode(email, code) {
	const body = {
		email_address: email,
		code: code
	}

	return (
		axios.post(API_ROOT + '/portal/check-code/', body)
	)
}

export function resetPortalPassword(email, code, password) {
	const body = {
		email_address: email,
		code: code,
		password: password
	}

	return (
		axios.post(API_ROOT + '/portal/reset/', body)
	)
}

export function getPortalTeamupAuthURI(id) {
	return axios.get(API_ROOT + '/portal/teamup-auth-uri/' + id , { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function retrievePortalTeamupAccessToken(id, state, code) {
	const body = {
		user_id: id,
		state: state,
		code: code
	}
	return axios.post(API_ROOT + '/portal/retrieve-teamup-access-token', body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function revokePortalTeamupAccess(id) {
	const body = {
		user_id: id
	}
	return axios.post(API_ROOT + '/portal/revoke-teamup-access', body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function modifyUser(userId, portalId, mods) {
	mods['local_today'] = toDateString(new Date());

	return axios.put(API_ROOT + `/portal/users/${userId}/${portalId}`, mods, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function updateAuxiliary(userId, portalId, data) {
	data['local_today'] = toDateString(new Date());

	return axios.put(API_ROOT + `/portal/auxiliary/${userId}/${portalId}`, data, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function saveHighLow(userId, portalId, highLowFactor, highLowMask, highLowTweaks, reportDate) {
	const data = {
		user_id: userId,
		portal_id: portalId,
		high_low_factor: highLowFactor,
		high_low_mask: highLowMask,
		high_low_tweaks: highLowTweaks,
		report_date: reportDate
	}
	return axios.post(API_ROOT + `/portal/highlow`, data, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function updateMacroAdjustment(userId, portalId, dateString, data) {
	return axios.put(API_ROOT + `/portal/macro-adjustment/${userId}/${portalId}/${dateString}`, data, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function insertWeighIn(userId, portalId, weight, bf, compliant, menstrual, skipNearPeriod, goal_change_requested, activity_level_change_requested, mods, estimated_weight) {
	return new Promise((resolve, reject) => {
		const req = {
			user_id: userId,
			portal_id: portalId,
			weight: weight,
			estimated_weight: estimated_weight,
			body_fat: bf,
			compliant: compliant,
			near_period: menstrual,
			goal_change_requested: goal_change_requested,
			activity_level_change_requested: activity_level_change_requested,
			local_today: toDateString(new Date())
		}

		// if(skipNearPeriod)
		// 	req['skip_near_period'] = skipNearPeriod

		axios.post(API_ROOT + '/portal/weighins/', req, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
			.then((res) => {
			if(_.size(mods) > 0) {
				mods['local_today'] = toDateString(new Date());
				axios.put(API_ROOT + `/portal/users/${userId}/${portalId}`, mods, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
				.then((res) => {
					// setTimeout(() => dispatch({ type: 'WEIGH_IN_AND_MODIFY_USER_FULFILLED', payload: res.data }), 2000);
					// setTimeout(() => dispatch(loadProfile(id)), 2000);
					resolve(res)
				}).catch((err) => reject(err));
			} else {
				// setTimeout(() => dispatch({ type: 'WEIGH_IN_FULFILLED', payload: Object.assign({}, res.data, { report_date: req.local_today }) }), 2000);
				// setTimeout(() => dispatch(loadProfile(id)), 2000);
				resolve(res);
			}
			}).catch((err) => {
				// dispatch({ type: 'WEIGH_IN_REJECTED',
				// payload: {
				// 	message: 'Unable to submit check-in. Please try again'
				// }
				// })
				reject(err);
			})
	});
}

export function resumeWeighIn(id, portalId, weight, bf, menstrual, skipNearPeriod, estimatedWeight) {
	return new Promise((resolve, reject) => {
		const req = {
			weight: weight,
			body_fat: bf,
			near_period: menstrual,
			local_today: toDateString(new Date()),
			estimated_weight: estimatedWeight,
		}

		if(skipNearPeriod)
			req['skip_near_period'] = skipNearPeriod

		if(estimatedWeight)
			req['estimated_weight'] = estimatedWeight

		axios.post(API_ROOT + `/portal/resume/${id}/${portalId}`, req, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }}).then(
			res => {
			resolve(res);
			},
			err => {
			reject(err);
			})
	})
}

export function editCheckWeighIn(request) {
	return new Promise((resolve, reject) => {
		axios.put(API_ROOT + '/portal/weighins/', request,  { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }}).then((res) => {
			resolve(res)
		}).catch((err) => { reject(err) })
	})
}

export function editAddWeighIn(request) {
	return new Promise((resolve, reject) => {
	axios.put(API_ROOT + '/portal/weighins/', request,  { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }}).then((res) => {
		resolve(res)
	}).catch((err) => { reject(err) })
	})
}

export function editWeighIn(request) {
	return new Promise((resolve, reject) => {
	axios.put(API_ROOT + '/portal/weighins/', request,  { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }}).then((res) => {
		resolve(res)
	}).catch((err) => { reject(err) })
	})
}

export function retrievePortalEzfacilityAccessToken(id, username, password) {
	const body = {
		user_id: id,
		username: username,
		password: password
	}
	return axios.post(API_ROOT + '/portal/retrieve-ezfacility-access-token', body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function revokePortalEzfacilityAccess(id) {
	const body = {
		user_id: id
	}
	return axios.post(API_ROOT + '/portal/revoke-ezfacility-access', body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function createSubAccount(requester_id, email, name) {
	const body = {
		email_address: email,
		name: name,
	}

	return (
		axios.post(`${API_ROOT}/portal/user/${requester_id}`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function updateSubAccount(requester_id, edit_id, mods) {
	return (
		axios.put(`${API_ROOT}/portal/user/${requester_id}/${edit_id}`, mods, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function assignTrainer(requester_id, account_id, trainer_id) {
	const body = {
		account_id: account_id,
		trainer_id: trainer_id,
	}

	return (
		axios.post(`${API_ROOT}/portal/trainer/${requester_id}`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function removeTrainer(requester_id, account_id, trainer_id) {
	return (
		axios.delete(`${API_ROOT}/portal/trainer/${requester_id}/${account_id}/${trainer_id}`, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function bulkRemoveTrainer(requester_id, account_id, trainer_id) {
	const body = {
		account_id: account_id,
		trainer_id: trainer_id,
	}

	return (
		axios.post(`${API_ROOT}/portal/bulk-remove-trainer/${requester_id}`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function createGroup(requester_id, name) {
	const body = {
		name: name,
	}

	return (
		axios.post(`${API_ROOT}/portal/group/${requester_id}`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function updateGroup(requester_id, group_id, name) {
	const body = {
		name: name,
	}

	return (
		axios.put(`${API_ROOT}/portal/group/${requester_id}/${group_id}`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function deleteGroup(requester_id, group_id) {
	return (
		axios.delete(`${API_ROOT}/portal/group/${requester_id}/${group_id}`, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function assignToGroup(requester_id, account_id, group_id) {
	const body = {
		account_id: account_id,
		group_id: group_id,
	}

	return (
		axios.post(`${API_ROOT}/portal/group-assignment/${requester_id}`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function removeFromGroup(requester_id, account_id, group_id) {
	return (
		axios.delete(`${API_ROOT}/portal/group-assignment/${requester_id}/${account_id}/${group_id}`, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function bulkRemoveFromGroup(requester_id, account_id, group_id) {
	const body = {
		account_id: account_id,
		group_id: group_id,
	}

	return (
		axios.post(`${API_ROOT}/portal/bulk-remove-group-assignment/${requester_id}`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function sendGroupNotification(requester_id, group_id, title, message) {
	const body = {
		group_id: group_id,
		title: title,
		message: message,
	}

	return (
		axios.post(`${API_ROOT}/portal/group-notification/${requester_id}`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function getCampaigns(requester_id) {
	return axios.get(API_ROOT + '/portal/campaigns/' + requester_id, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function createCampaign(requester_id, name) {
	const body = {
		name: name
	}

	return (
		axios.post(`${API_ROOT}/portal/create-campaign/${requester_id}`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function updateCampaign(requester_id, campaign_id, name) {
	const body = {
		name: name
	}

	return (
		axios.post(`${API_ROOT}/portal/update-campaign/${requester_id}/${campaign_id}`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function getCampaignInfo(requester_id, campaign_id) {
	return axios.get(API_ROOT + '/portal/campaign/' + requester_id + '/' + campaign_id, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function startCampaign(requester_id, campaign_id, times) {
	const body = {
		times: times
	}

	return (
		axios.post(`${API_ROOT}/portal/start-campaign/${requester_id}/${campaign_id}`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function cloneCampaign(requester_id, campaign_id, name) {
	const body = {
		campaign_id: campaign_id,
		name: name
	}

	return (
		axios.post(`${API_ROOT}/portal/clone-campaign/${requester_id}`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function deleteCampaign(requester_id, campaign_id) {
	return (
		axios.delete(`${API_ROOT}/portal/campaign/${requester_id}/${campaign_id}`, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function insertCampaignStep(requester_id, campaign_id, after, wait_type, wait_duration, wait_until_time, message) {
	const body = {
		after: after,
		wait_type: wait_type,
		wait_duration: wait_duration,
		wait_until_time: wait_until_time,
		message: message
	}

	return (
		axios.post(`${API_ROOT}/portal/insert-campaign-step/${requester_id}/${campaign_id}`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function updateCampaignStep(requester_id, campaign_id, step_id, wait_type, wait_duration, wait_until_time, message) {
	const body = {
		wait_type: wait_type,
		wait_duration: wait_duration,
		wait_until_time: wait_until_time,
		message: message
	}

	return (
		axios.post(`${API_ROOT}/portal/update-campaign-step/${requester_id}/${campaign_id}/${step_id}`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function deleteCampaignStep(requester_id, campaign_id, step_id) {
	return (
		axios.delete(`${API_ROOT}/portal/campaign-step/${requester_id}/${campaign_id}/${step_id}`, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function addCampaignRecipient(requester_id, campaign_id, account_id) {
	const body = {
		account_id: account_id
	}

	return (
		axios.post(`${API_ROOT}/portal/add-campaign-recipient/${requester_id}/${campaign_id}`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function deleteCampaignRecipient(requester_id, campaign_id, account_id) {
	return (
		axios.delete(`${API_ROOT}/portal/campaign-recipient/${requester_id}/${campaign_id}/${account_id}`, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function getHqChallenges(requester_id) {
	return axios.get(API_ROOT + '/portal/hq-challenges/' + requester_id, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function addHqChallengeParticipant(requester_id, challenge_id, account_id) {
	const body = {
		account_id: account_id
	}

	return (
		axios.post(`${API_ROOT}/portal/add-hq-challenge-participant/${requester_id}/${challenge_id}`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function deleteHqChallengeParticipant(requester_id, challenge_id, account_id) {
	return (
		axios.delete(`${API_ROOT}/portal/hq-challenge-participant/${requester_id}/${challenge_id}/${account_id}`, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function getWeeklySummaryData2(id, all, interval) {
	const local_today = toDateString(new Date());

	return axios.get(API_ROOT + '/portal/weekly-summary-data2/' + id + '/' + all + '/' + local_today + '/' + interval, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function getFavoriteMeals(id) {
	return axios.get(API_ROOT + '/portal/favorite-meals/' + id, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function insertFavoriteMeal(requester_id, name, foods, notes) {
	const body = {
		name: name,
		foods: foods,
		notes: notes,
	}

	return (
		axios.post(`${API_ROOT}/portal/favorite-meals/${requester_id}`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function updateFavoriteMeal(requester_id, meal_id, name, foods, notes) {
	const body = {
		id: meal_id,
		name: name,
		foods: foods,
		notes: notes,
	}

	return (
		axios.put(API_ROOT + '/portal/favorite-meal/' + requester_id + '/' + meal_id, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function deleteFavoriteMeal(requester_id, meal_id) {
	return (
		axios.delete(API_ROOT + '/portal/favorite-meal/' + requester_id + '/' + meal_id, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function shareMealsMultiple(requester_id, ids, sharing) {
	const body = {
		ids: ids,
		sharing: sharing,
	}

	return (
		axios.post(`${API_ROOT}/portal/share-meals-multiple/${requester_id}`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function getMealSharing(requester_id, meal_id) {
	return axios.get(API_ROOT + '/portal/meal-sharing/' + requester_id + '/' + meal_id, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function getFavoriteDays(id) {
	return axios.get(API_ROOT + '/portal/favorite-days/' + id, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function insertFavoriteDay(requester_id, name, meals, notes) {
	const body = {
		name: name,
		meals: meals,
		notes: notes,
	}

	return (
		axios.post(`${API_ROOT}/portal/favorite-days/${requester_id}`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function updateFavoriteDay(requester_id, day_id, name, meals, notes) {
	const body = {
		id: day_id,
		name: name,
		meals: meals,
		notes: notes,
	}

	return (
		axios.put(API_ROOT + '/portal/favorite-day/' + requester_id + '/' + day_id, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function deleteFavoriteDay(requester_id, day_id) {
	return (
		axios.delete(API_ROOT + '/portal/favorite-day/' + requester_id + '/' + day_id, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function shareDaysMultiple(requester_id, ids, sharing) {
	const body = {
		ids: ids,
		sharing: sharing,
	}

	return (
		axios.post(`${API_ROOT}/portal/share-days-multiple/${requester_id}`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function getDaySharing(requester_id, day_id) {
	return axios.get(API_ROOT + '/portal/day-sharing/' + requester_id + '/' + day_id, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function setStripeKey(requester_id, key) {
	const body = {
		user_id: requester_id,
		key: key,
	}

	return (
		axios.post(`${API_ROOT}/portal/set-stripe-key`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function disableStripe(requester_id) {
	const body = {
		user_id: requester_id,
	}

	return (
		axios.post(`${API_ROOT}/portal/disable-stripe`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function getStripeStoreData(id) {
	return axios.get(API_ROOT + '/portal/stripe-store-data/' + id , { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function addStripeLandingPage(requester_id, name, enabled, prices) {
	const body = {
		user_id: requester_id,
		name: name,
		enabled: enabled,
		data: { prices }
	}

	return (
		axios.post(`${API_ROOT}/portal/add-stripe-landing-page`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function updateStripeLandingPage(requester_id, id, name, enabled, prices) {
	const body = {
		user_id: requester_id,
		id: id,
		name: name,
		enabled: enabled,
		data: { prices }
	}

	return (
		axios.post(`${API_ROOT}/portal/update-stripe-landing-page`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function deleteStripeLandingPage(requester_id, id) {
	const body = {
		user_id: requester_id,
		id: id
	}

	return (
		axios.post(`${API_ROOT}/portal/delete-stripe-landing-page`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function getStreamChatToken(portal_id) {
	return (
		axios.get(`${API_ROOT}/stream-chat-user-token/${portal_id}`, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function createStreamPortalTrainers(portal_id, createTrainers) {
	const body = {
		create_trainers: createTrainers,
	}

	return (
		axios.post(`${API_ROOT}/stream-chat-create-trainers/${portal_id}`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function getOrCreatePortalChannel(portal_id, user_id) {
	const body = {
		covered_user: user_id,
	}

	return (
		axios.post(`${API_ROOT}/stream-chat-portal-channel/${portal_id}`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function setProfilePicture(pic, name, id) {
	return (
		axios.put(API_ROOT + '/upload-portal/', { file_name: name, user_id: id }, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }}).then((res) => {
			axios.put(res.data, pic)
		})
	)
}

// members is an array of stream ids from a channel
export function checkGroupLinks(user_id, members, signal) {
	let body = {
		members: members
	};

	body['signal'] = signal

	return axios.post(`${API_ROOT}/stream-chat-check-links/${user_id}`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function bulkEditCheckinDay(user_id, data) {
	return axios.post(`${API_ROOT}/portal/batch-set-check-in-day/${user_id}`, data, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function copyFavoriteMeal(requester_id, meal_id) {
	const body = {
		meal_id: meal_id
	}

	return (
		axios.post(`${API_ROOT}/portal/copy-favorite-meals/${requester_id}`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function copyFavoriteDay(requester_id, day_id) {
	const body = {
		day_id: day_id
	}

	return (
		axios.post(`${API_ROOT}/portal/copy-favorite-days/${requester_id}`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}

export function getPortalSurveys(requester_id) {
	return axios.get(`${API_ROOT}/portal/survey/${requester_id}`, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function getPortalSurveyResponse(requester_id, client_user_id) {
	return axios.get(`${API_ROOT}/portal/survey-response/${requester_id}/${client_user_id}`, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function createPortalSurvey(requester_id, surveyData) {
	return axios.post(`${API_ROOT}/portal/survey/${requester_id}`, surveyData, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function updatePortalSurvey(requester_id, survey_id, survey) {
	return axios.put(`${API_ROOT}/portal/survey/${requester_id}/${survey_id}`, survey, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function deletePortalSurvey(requester_id, survey_id) {
	return axios.delete(`${API_ROOT}/portal/survey/${requester_id}/${survey_id}`, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function addSurveyAssignment(requester_id, survey_id, account_ids) {
	return axios.post(`${API_ROOT}/portal/survey-assign/${requester_id}/${survey_id}`, account_ids, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function deleteSurveyAssignment(requester_id, account_ids) {
	return axios.post(`${API_ROOT}/portal/survey-assignment-delete/${requester_id}`, { account_ids }, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function importPortalSurvey(requester_id, survey_share_id, name) {
	return axios.post(`${API_ROOT}/portal/survey-import/${requester_id}`, { survey_share_id, name }, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function addSurveySchedule(requester_id, schedule) {
	return axios.post(`${API_ROOT}/portal/survey-schedule/${requester_id}`, schedule, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function updateSurveySchedule(requester_id, schedule_id, schedule) {
	return axios.put(`${API_ROOT}/portal/survey-schedule/${requester_id}/${schedule_id}`, schedule, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function deleteSurveySchedule(requester_id, schedule_id) {
	return axios.delete(`${API_ROOT}/portal/survey-schedule/${requester_id}/${schedule_id}`, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function batchSetVacationMode(requester_id, data) {
	return axios.post(`${API_ROOT}/portal/batch-set-vacation-mode/${requester_id}`, data, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function getResponseCheckinData(requester_id, user_id, weightId) {
	return axios.get(`${API_ROOT}/portal/response-checkin-data/${requester_id}/${user_id}/${weightId}`, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function getRecommendedMacros(requester_id, accountID) {
	return axios.get(`${API_ROOT}/portal/recommended/${requester_id}/${accountID}`, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
}

export function getPortalLogs(requester_id, params = {}) {
	return axios.get(`${API_ROOT}/portal/logs/${requester_id}`, {
		params,
		headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }
	})
}

export function logGroupMessage(requester_id, group_id, metadata) {
	const body = {
		group_id: group_id,
		...metadata,
	}

	return (
		axios.post(`${API_ROOT}/portal/log-group-message/${requester_id}`, body, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
	)
}